import { Component } from '@angular/core';
import { LEGAL_INFO } from '../legal-info';

@Component({
    selector: 'app-terms',
    templateUrl: './terms.component.html',
    styleUrls: ['../legal.scss'],
    standalone: false
})
export class TermsComponent {
  info = LEGAL_INFO;
}
